import { Suspense, useEffect } from 'react'
import { useMeasures } from '../../../hooks/state/useMeasures'
import { AttachedBar } from './bar/AttachedBar'
import { LogsBack } from './log/LogsBack'
import { LogsFront } from './log/LogsFront'
import { QubusBar } from './roof/bar/QubusBar'
import { Roof } from './roof/Roof'
import { SidewallSpawner } from './side/SidewallSpawner'
import { FrontBar } from './bar/FrontBar'
import { Helper } from '../../../classes/helper'
interface TerraceCoverMeshProps {
  onLoad: () => void
}

export const TerraceCoverMesh: React.FC<TerraceCoverMeshProps> = ({
  onLoad,
}) => {
  const {
    attachment,
    polesNumber,
    frontBarTyp,
    isQuer,
    depth,
    userWidth,
    isQubus,
    eaves,
    eavesHeight,
    userHeight,
    userAngle,
    schwelleSize,
    attachedSize,
  } = useMeasures()

  useEffect(() => {
    const loadMesh = async () => {
      await new Promise((resolve) => setTimeout(resolve, 500))

      onLoad()
    }

    loadMesh()
  }, [onLoad])

  const logHeight = eaves
    ? eavesHeight + 0.02
    : userHeight -
      Helper.calculateTriangleSideLength(
        userAngle,
        90,
        depth - attachedSize.z - schwelleSize.depth - 0.02
      ).a
  return (
    <group
      position={[isQuer ? 0 : -depth / 2, 0, isQuer ? 0 : userWidth / 2]}
      name={'k3d'}
      rotation={isQuer ? [0, 0, 0] : [0, ((90 % 360) * Math.PI) / 180, 0]}
    >
      {(!isQubus || (isQubus && frontBarTyp !== '$noSelection')) && (
        <Suspense fallback={null}>
          {!isQubus && <AttachedBar />}

          {!isQubus && <FrontBar />}
          <LogsFront polesNumber={polesNumber} height={logHeight} />
          {attachment.free && <LogsBack />}
        </Suspense>
      )}

      {isQubus && (
        <group>
          <QubusBar />
        </group>
      )}
      <Roof />
      <Suspense fallback={null}>
        <SidewallSpawner />
      </Suspense>
    </group>
  )
}
